import { Component } from 'react';
import { Card } from 'react-bootstrap'
import { commentIcon } from '../../img/font_awesome/font_awesome';
import translations from "../../config/translation/home_translations.json"
import { connect } from "react-redux";
import axios from "axios";
import configData from "../../config/config.json";
import { handleError } from '../../redux/actions/commonStuff';
import { LOADING_STATUES } from "../constants/constants";

const mapStateToProps = state => {
    return {
        language: state.languageReducer ? state.languageReducer : 'ENGLISH'
    };
}

class Disclaimer extends Component {
    state = {
        disclaimerLink: null,
        loadingStatus: ""
    }

    showLoading = () => {
        if (this.state.loadingStatus === "") {
            this.setState({
                loadingStatus: LOADING_STATUES.LOADING
            })
            return true;
        }
        return false;
    }

    hideLoading = () => {
        this.setState({
            loadingStatus: ""
        })
    }
    componentDidMount() {
        this.showLoading();
        axios.get(configData.LANDNOTIFICATION_SERVER_URL + "home/links?language=" + this.props.language, { withCredentials: true })
            .then(
                (response) => {
                    let disclaimerLink = null;
                    let links = response.data.content.paragraphs;
                    if (links && links.length > 0) {
                        const fitleredDisclaimerList = links.filter(link => link.heading === 'Disclaimer');
                        if (fitleredDisclaimerList && fitleredDisclaimerList.length === 1) {
                            disclaimerLink = fitleredDisclaimerList[0].paragraphContent;
                            this.setState({
                                disclaimerLink
                            }, function () {   // callback function after the state is set
                                this.hideLoading();
                            });
                        }
                    }
                },
                (error) => {
                    handleError(error, this.props.history);
                }
            );
    }

    render() {
        let disclaimerLink = <></>;
        if (this.state.disclaimerLink) {
            disclaimerLink = <ul style={{ listStyle: 'none' }}><li><a target="_blank" rel="noopener noreferrer" href={this.state.disclaimerLink} style={{ color: '#3675A5', fontWeight: 'bold' }}>{translations[this.props.language].click}&nbsp;{translations[this.props.language].here}</a></li></ul>
        }

        return (
            <Card>
                <Card.Header className='card-header-light'>
                    {commentIcon}&nbsp;&nbsp;{translations[this.props.language].disclaimer}
                </Card.Header>
                <Card.Body>
                    {disclaimerLink}
                </Card.Body>
            </Card >
        )
    }
}

export default connect(mapStateToProps)(Disclaimer);
